import { FC } from 'react';

import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import {
  compose,
  display,
  DisplayProps,
  flex,
  FlexProps,
  layout,
  LayoutProps,
  variant,
  space,
  SpaceProps,
  ThemeProps
} from '@lucid/theme';

export interface CardContentProps
  extends ThemeProps,
  DisplayProps,
  FlexProps,
  LayoutProps,
  SpaceProps {
  /** Allows the component to get additional styles. */
  className?: string;
}

const cardContentStyleProps = compose(flex, display, layout, space);

const StyledCardContent: FC<CardContentProps> = styled.div(
  {
    label: 'cardContent'
  },
  variant({
    scale: 'card.content',
    variants: {
      defaultVariant: {}
    }
  }),
  cardContentStyleProps
);

const CardContent = withTheme(StyledCardContent);

export { CardContent };
export default CardContent;
